module.exports = __webpack_public_path__ + "static/media/verve11.8ffdf5e2.jpg";